"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATION_ERRORS = void 0;
const en_1 = require("./en");
exports.VALIDATION_ERRORS = {
    en: en_1.EN_ERRORS,
};
